import {
  getCustomerPricingExportList,
  uploadCustomerPricingData,
} from "@crescentParts/Services/CustomerPricingService";
import { CustomApiHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any>;

export const StartLoading: HandlerType = (props) => {
  props.dispatch({
    type: "Custom/LoadCustomerPricing",
  });
};

export const UploadCustomerPricingGetExportedListCompleted: HandlerType =
  async (props) => {
    if (props.parameter) {
      try {
        const result: any = await uploadCustomerPricingData(
          props.parameter.aPiparameter,
        );
        // result may already be an object; only parse if it's a string
        let response: any;
        if (typeof result === "string") {
          try {
            response = JSON.parse(result);
          } catch {
            // If parsing fails, keep the raw string
            response = result;
          }
        } else {
          response = result;
        }

      } catch (error) {
        throw error;
      }
    }
  };

export const CustomerPricingGetExportedListCompleted: HandlerType = async (
  props,
) => {
  if (props.parameter) {
    try {
      const currentDate = new Date().toISOString();
      const encodedDate = encodeURIComponent(currentDate);

      const result: any = await getCustomerPricingExportList(
        `/api/v2/CustomerPricing/ExportHistory?page=1&date=%27${encodedDate}%27`,
      );
      // result may already be an object; only parse if it's a string
      let response: any;
      if (typeof result === "string") {
        try {
          response = JSON.parse(result);
        } catch {
          // If parsing fails, keep the raw string
          response = result;
        }
      } else {
        response = result;
      }

      if (response) {
        props.dispatch({
          type: "Custom/DispatchLoadCustomerPricing",
          exportList: response,
        });
      }
    } catch (error) {
      throw error;
    }
  }
};

export const chain = [
  StartLoading,
  UploadCustomerPricingGetExportedListCompleted,
  CustomerPricingGetExportedListCompleted,
];

const uploadCustomerPricing = createHandlerChainRunner(
  chain,
  "uploadCustomerPricing",
);
export default uploadCustomerPricing;
